<div class="invoice-list-header">
  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" [value]="getListFilter()" placeholder="Filter">
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="bulkSendToAccounting()" [disabled]="selection.length === 0">Bulk
    send to accounting</button>
</div>

<div class="example-container mat-elevation-z8">

  <mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef i18n>Select</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox *ngIf="!row.sentToAccounting" [checked]="isInSelection(row)"
          (change)="toggleInvoiceSelection(row, $event)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoiceNr">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Invoice Nr.</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.invoiceNr2">{{ row.invoiceNr }}/{{ row.invoiceNr2 }}</span>
        <span *ngIf="!row.invoiceNr2">{{ row.invoiceNr }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="downloadUrl">
      <mat-header-cell *matHeaderCellDef i18n>Document</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.downloadUrl">
          <a [href]="row.downloadUrl" target="_blank">
            <mat-icon matListIcon>attach_file</mat-icon>
          </a>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="note">
      <mat-header-cell *matHeaderCellDef i18n>Description</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.note }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Vendor</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div> {{ row.order?.vendor?.name }} </div>
        <a *ngIf="row.order.primaryContact?.emails" target="_blank"
          [href]="'https://mail.google.com/mail/u/0/?view=cm&fs=1&to='+ row.order.primaryContact.emails[0].email">
          <span class="author-email">
            {{ row.order?.primaryContact?.name }}
          </span>
          <span class="author-email">
            &#x3C;{{ row.order?.primaryContact?.emails[0].email }}&#x3E;
          </span>
        </a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="orderNr">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Order Nr.</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.order.orderNr }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoiceDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Invoice Date</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.invoiceDate | date }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amount">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Amount</mat-header-cell>
      <mat-cell *matCellDef="let row"><span *ngIf="row.totalAmount"> {{ row.totalAmount | currency:'EUR' }} </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sentToAccounting">
      <mat-header-cell *matHeaderCellDef i18n>Sent To Accounting</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-icon *ngIf="row.sentToAccounting" matListIcon>done</mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef i18n>Actions</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <a mat-icon-button [routerLink]="['/invoices',row.id]">
          <mat-icon *ngIf="!row.sentToAccounting">mode_edit</mat-icon>
          <mat-icon *ngIf="row.sentToAccounting">visibility</mat-icon>
        </a>
        <!--<button mat-icon-button [disabled]="row.sentToAccounting" (click)="deleteInvoices(row)">
              <mat-icon>delete</mat-icon>
            </button>-->
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
  </mat-table>

  <mat-paginator [length]="dataSource.resultsLength" pageSize="100" [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/invoices/invoices-list/invoices-list.component.html